module.exports = __webpack_public_path__ + "static/media/Steph.86b70cde.jpg";